// `/app/developers/webhooks` virou `/app/developers?tab=webhooks` (WEB-121): a tela morou
// aqui até a WEB-57/108, agora é a aba padrão de "Webhooks e API". Rota mantida só como
// redirect, preservando `?id=` (o endpoint aberto no drawer de detalhe).

import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/app/developers/webhooks/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/app/developers', search: { tab: 'webhooks', id: search.id } });
  },
});
